/**
 * Simple promise-based sleep utility. Used by fetchWithRetry for backoff delays.
 */
export function sleep(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
